import { Authenticated } from "@/v2/application/authenticated";
import { createSelector } from "@reduxjs/toolkit";
export const getAuthenticatedFrame = createSelector(Authenticated.Selectors.getAuthenticated, Authenticated.Selectors.getIsLoggedIn, (authenticated, isLoggedIn) => {
    var _a, _b;
    return ({
        user: (_a = authenticated === null || authenticated === void 0 ? void 0 : authenticated.auth) === null || _a === void 0 ? void 0 : _a.user,
        org: (_b = authenticated === null || authenticated === void 0 ? void 0 : authenticated.auth) === null || _b === void 0 ? void 0 : _b.current_organization,
        features: authenticated === null || authenticated === void 0 ? void 0 : authenticated.features,
        isLoggedIn,
    });
});
